import { BAffix } from '@bigin/components/affix'
import { BAlert } from '@bigin/components/alert'
import { BAutocomplete } from '@bigin/components/autocomplete'
import { BAvatar } from '@bigin/components/avatar'
import { BBacktop } from '@bigin/components/backtop'
import { BBadge } from '@bigin/components/badge'
import { BBreadcrumb, BBreadcrumbItem } from '@bigin/components/breadcrumb'
import { BButton, BButtonGroup } from '@bigin/components/button'
import { BCalendar } from '@bigin/components/calendar'
import { BCard } from '@bigin/components/card'
import { BCarousel, BCarouselItem } from '@bigin/components/carousel'
import { BCascader } from '@bigin/components/cascader'
import { BCascaderPanel } from '@bigin/components/cascader-panel'
import {
  BBarChart,
  BBubbleChart,
  BChart,
  BDonutChart,
  BLineChart,
  BPieChart,
  BPolarAreaChart,
  BRadarChart,
  BScatterChart,
} from '@bigin/components/chart'
import { BCheckTag } from '@bigin/components/check-tag'
import {
  BCheckbox,
  BCheckboxButton,
  BCheckboxGroup,
} from '@bigin/components/checkbox'
import { BCol } from '@bigin/components/col'
import { BCollapse, BCollapseItem } from '@bigin/components/collapse'
import { BCollapseTransition } from '@bigin/components/collapse-transition'
import { BColorPicker } from '@bigin/components/color-picker'
import { BConfigProvider } from '@bigin/components/config-provider'
import {
  BAside,
  BContainer,
  BFooter,
  BHeader,
  BMain,
  BSpacer,
} from '@bigin/components/container'
import { BDatePicker } from '@bigin/components/date-picker'
import {
  BDescriptions,
  BDescriptionsItem,
} from '@bigin/components/descriptions'
import { BDialog } from '@bigin/components/dialog'
import { BDivider } from '@bigin/components/divider'
import { BDrawer } from '@bigin/components/drawer'
import {
  BDropdown,
  BDropdownItem,
  BDropdownMenu,
} from '@bigin/components/dropdown'
import { BEmpty } from '@bigin/components/empty'
import { BForm, BFormItem } from '@bigin/components/form'
import { BIcon } from '@bigin/components/icon'
import { BImage } from '@bigin/components/image'
import { BImageViewer } from '@bigin/components/image-viewer'
import { BInput } from '@bigin/components/input'
import { BNumericInput } from '@bigin/components/numeric-input'
import { BLink } from '@bigin/components/link'
import { BLottie } from '@bigin/components/lottie'
import {
  BMenu,
  BMenuItem,
  BMenuItemGroup,
  BMenuToggle,
} from '@bigin/components/menu'
import { BPageHeader } from '@bigin/components/page-header'
import { BPagination } from '@bigin/components/pagination'
import { BPopconfirm } from '@bigin/components/popconfirm'
import { BPhoneInput } from '@bigin/components/phone-input'
import { BPopover } from '@bigin/components/popover'
import { BPopper } from '@bigin/components/popper'
import { BProgress } from '@bigin/components/progress'
import { BRadio, BRadioButton, BRadioGroup } from '@bigin/components/radio'
import { BRate } from '@bigin/components/rate'
import { BResult } from '@bigin/components/result'
import { BRow } from '@bigin/components/row'
import { BScrollbar } from '@bigin/components/scrollbar'
import { BOption, BOptionGroup, BSelect } from '@bigin/components/select'
import { BSelectV2 } from '@bigin/components/select-v2'
import { BSkeleton, BSkeletonItem } from '@bigin/components/skeleton'
import { BSlider } from '@bigin/components/slider'
import { BSpace } from '@bigin/components/space'
import { BStep, BSteps } from '@bigin/components/steps'
import { BSwitch } from '@bigin/components/switch'
import { BTable, BTableColumn } from '@bigin/components/table'
import { BAutoResizer, BTableV2 } from '@bigin/components/table-v2'
import { BTabPane, BTabs } from '@bigin/components/tabs'
import { BTag } from '@bigin/components/tag'
import { BTagInput } from '@bigin/components/tag-input'
import { BTimePicker } from '@bigin/components/time-picker'
import { BTimeSelect } from '@bigin/components/time-select'
import { BTimeline, BTimelineItem } from '@bigin/components/timeline'
import { BTooltip } from '@bigin/components/tooltip'
import { BTooltipV2 } from '@bigin/components/tooltip-v2'
import { BTransfer } from '@bigin/components/transfer'
import { BTree } from '@bigin/components/tree'
import { BTreeSelect } from '@bigin/components/tree-select'
import { BTreeV2 } from '@bigin/components/tree-v2'
import { BUpload } from '@bigin/components/upload'
import type { Plugin } from 'vue'

export default [
  BAffix,
  BAlert,
  BAutocomplete,
  BAutoResizer,
  BAvatar,
  BBacktop,
  BBadge,
  BBreadcrumb,
  BBreadcrumbItem,
  BButton,
  BButtonGroup,
  BCalendar,
  BCard,
  BCarousel,
  BCarouselItem,
  BCascader,
  BCascaderPanel,
  BChart,
  BBarChart,
  BLineChart,
  BBubbleChart,
  BPieChart,
  BDonutChart,
  BPolarAreaChart,
  BRadarChart,
  BScatterChart,
  BCheckTag,
  BCheckbox,
  BCheckboxButton,
  BCheckboxGroup,
  BCol,
  BCollapse,
  BCollapseItem,
  BCollapseTransition,
  BColorPicker,
  BConfigProvider,
  BContainer,
  BAside,
  BFooter,
  BHeader,
  BMain,
  BDatePicker,
  BDescriptions,
  BDescriptionsItem,
  BDialog,
  BDivider,
  BDrawer,
  BDropdown,
  BDropdownItem,
  BDropdownMenu,
  BEmpty,
  BForm,
  BFormItem,
  BIcon,
  BImage,
  BImageViewer,
  BInput,
  BNumericInput,
  BLink,
  BLottie,
  BMenu,
  BMenuItem,
  BMenuItemGroup,
  BMenuToggle,
  BPageHeader,
  BPagination,
  BPopconfirm,
  BPhoneInput,
  BPopover,
  BPopper,
  BProgress,
  BRadio,
  BRadioButton,
  BRadioGroup,
  BRate,
  BResult,
  BRow,
  BScrollbar,
  BSelect,
  BOption,
  BOptionGroup,
  BSelectV2,
  BSkeleton,
  BSkeletonItem,
  BSlider,
  BSpace,
  BSpacer,
  BSteps,
  BStep,
  BSwitch,
  BTable,
  BTableColumn,
  BTableV2,
  BTabs,
  BTabPane,
  BTag,
  BTagInput,
  BTimePicker,
  BTimeSelect,
  BTimeline,
  BTimelineItem,
  BTooltip,
  BTooltipV2,
  BTransfer,
  BTree,
  BTreeSelect,
  BTreeV2,
  BUpload,
] as unknown as Plugin[]
